"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.HintMessage = exports.Hint = void 0;
var _mui = require("@ori-ui/mui");
var _jsxRuntime = require("react/jsx-runtime");
const Hint = exports.Hint = (0, _mui.styled)(_mui.Alert)((param)=>{
    let { theme } = param;
    return {
        marginTop: theme.spacing(2),
        width: '100%'
    };
});
const HintMessage = (param)=>{
    let { message, ...rest } = param;
    const props = {
        variant: 'standard',
        severity: 'info',
        color: 'default',
        ...rest
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(Hint, {
        ...props,
        children: message
    });
};
exports.HintMessage = HintMessage;
